import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
} from "react";
import { useTranslation } from "react-i18next";
import { RTL_LANGUAGES, SUPPORTED_LANGUAGES } from "../../../i18n";

const LanguageContext = createContext(null);

const applyDirection = (langCode) => {
  const dir = RTL_LANGUAGES.includes(langCode) ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", langCode);
};

const LanguageProvider = ({ children }) => {
  const { i18n, t } = useTranslation(["common"]); // 👈 t هم اضافه شد
  const lang = i18n.language;

  useEffect(() => {
    applyDirection(lang);
  }, [lang]);

  // 👇 جدید — تایتل صفحه رو با تغییر زبان آپدیت کن
  useEffect(() => {
    document.title = t("common:appTitle");
  }, [lang, t]);

  const setLang = useCallback(
    (next) => {
      i18n.changeLanguage(next);
    },
    [i18n]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, languages: SUPPORTED_LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

const useLanguage = () => useContext(LanguageContext);

export { LanguageProvider, useLanguage };